import React from 'react';
import { initial, isOnline } from '../lib/format';

export default function Avatar({ user, size = 48, ring = false, showPresence = false, showBotTag = false }) {
  const name = user?.username;
  const online = showPresence && isOnline(user?.lastSeen);

  return (
    <div style={{ position: 'relative', flexShrink: 0, width: size, height: size }}>
      <div
        className={`avatar${ring ? ' avatar-ring' : ''}`}
        style={{ width: size, height: size, fontSize: Math.max(12, size * 0.4) }}
      >
        {user?.profileImage ? <img src={user.profileImage} alt="" /> : initial(name)}
      </div>
      {online && <span className="avatar-presence" aria-hidden="true" />}
      {showBotTag && user?.isBot && <span className="avatar-tag">AI</span>}
    </div>
  );
}
